import { useCallback, useEffect, useState } from "react";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";

import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import Base64ToBlobV2 from "../../../../components/Formatters/Base64ToBlobV2";

const useBuscaAnexo = () => {
  const { request, data, isLoading, errors } = useApiClient();

  const [arquivoPendente, setArquivoPendente] = useState(null);

  const baixarAnexo = useCallback(
    (sqAcaoFiscal, sqItem, nomeArquivo) => {
      setArquivoPendente({
        sqAcaoFiscal,
        sqItem,
        nomeArquivo,
      });

      request(apiRoutes.fiscalizacao.ordemservico.buscaAnexoComunicado, {
        sqAcaoFiscal,
        sqItem,
      });
    },
    [request],
  );

  useEffect(() => {
    if (!arquivoPendente) return;
    if (isLoading) return;

    if (errors) {
      toast.error("Erro ao buscar o arquivo.");
      setArquivoPendente(null);
      return;
    }

    const conteudoBinario = data?.result?.[0]?.conteudoBinario ?? data?.result?.conteudoBinario ?? null;

    if (!conteudoBinario) {
      toast.error("Não foi possível obter o conteúdo do arquivo.");
      setArquivoPendente(null);
      return;
    }

    try {
      const blob = Base64ToBlobV2(conteudoBinario);
      saveAs(blob, arquivoPendente.nomeArquivo || "arquivo");
    } catch (error) {
      console.error("Erro ao processar arquivo:", error);
      toast.error("Erro ao realizar download do arquivo.");
    } finally {
      setArquivoPendente(null);
    }
  }, [data, isLoading, errors, arquivoPendente]);

  return {
    baixarAnexo,
    isLoading,
  };
};

export default useBuscaAnexo;
